import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './sidebar'
import { Header } from './header'
import { useSidebar } from '../contexts/sidebar-context'
import { cn } from '../lib/utils'

export default function Layout() {
  const { isCollapsed, isOpen } = useSidebar()
  const location = useLocation()
  const isPOSPage = location.pathname === '/pos' || location.pathname === '/dashboard/pos'
  
  return (
    <div className="min-h-screen bg-background">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content Area - shifts when sidebar opens so nothing is covered */}
      <div 
        className={cn(
          "flex flex-col min-h-screen transition-all duration-300",
          isOpen ? "ml-0 lg:ml-72" : "ml-0"
        )}
      >
        {/* Fixed Header */}
        <Header />
        
        {/* Main Content */}
        <main 
          className={isPOSPage 
            ? "flex-1 overflow-hidden pt-14 h-screen" 
            : "flex-1 overflow-y-auto pb-6 pt-14"
          } 
          id="main-content"
        >
          <Outlet />
        </main>
      </div>
    </div>
  )
}
